import ApplicationSerializer from './application';

export default class OktaIntegrationSerializer extends ApplicationSerializer {
  attrs = {
    tokenDisplay: { serialize: false },
  };
}
